export interface IMessage {
	message: string;
}

export enum SharingPreferenceIdType {
	// eslint-disable-next-line no-unused-vars
	connect = "connect",
	// eslint-disable-next-line no-unused-vars
	manual = "manual",
}
